import useAuth from 'src/hooks/useAuth';

const usePlantTerminology = () => {
    const { user } = useAuth();
    
    const isPlant3 = user?.idplant === 3;

    const getIdTeamForPlant = () => isPlant3 ? 10 : 2; //idteam=10 (vado), idteam=2 (savigliano)

    const getPlantLabel = (type) => {
        const labels = {
            detail: {
                default: 'pm.Dettaglio ciclo',
                plant3: 'pm.Dettaglio scheda'
            },
            cyclecreatecod: {
                default: 'Codice Ciclo',
                plant3: 'Codice Scheda'
            },
            cyclecreatedes: {
                default: 'Descrizione Ciclo',
                plant3: 'Descrizione Scheda'
            },
            cyclecreatedef: {
                default: 'Definizione Ciclo',
                plant3: 'Definizione Scheda'
            },
            cyclecreatedef2: {
                default: 'Definizione Cicli',
                plant3: 'Definizione Schede'
            },
            cyclecreatenew: {
                default: 'Nuovo Ciclo',
                plant3: 'Nuova Scheda'
            },
            entity: {
                default: 'pm.Ciclo',
                plant3: 'pm.Scheda'
            },
            navbar: {
                default: 'Definizione Cicli',
                plant3: 'Definizione Schede'
            },
            orderseditview: {
                default: 'pm.Rendicontazione ciclo',
                plant3: 'pm.Rendicontazione scheda'
            },
            smpcyclelistviewadd: {
                default: 'pm.Aggiungi a ciclo',
                plant3: 'pm.Aggiungi a a scheda'
            },
        };

        const item = labels[type];

        if (!item) {
            return '';
        }

        return isPlant3
            ? item.plant3
            : item.default;
    };

    return {
        getPlantLabel,
        getIdTeamForPlant,
        isPlant3
    };
};

export default usePlantTerminology;

